var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgLinkedIn({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 26,
    height: 26,
    viewBox: "0 0 26 26",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "none",
    fillRule: "nonzero"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 26,
    height: 26,
    fill: "#3274A5",
    rx: 13
  }), /*#__PURE__*/React.createElement("g", {
    fill: "#FFF"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M8.363 17.91h1.455c.201 0 .364-.176.364-.393v-6.853c0-.216-.163-.391-.364-.391H8.363c-.2 0-.363.175-.363.391v6.853c0 .217.163.392.363.392zM8.363 9.182h1.455c.201 0 .364-.176.364-.393V7.393c0-.217-.163-.393-.364-.393H8.363c-.2 0-.363.176-.363.393v1.396c0 .217.163.393.363.393zM19.404 11.243c-.222-.283-.55-.515-.985-.697a3.679 3.679 0 0 0-1.437-.273c-1.063 0-1.965.391-2.704 1.175-.147.156-.254.121-.254-.09v-.508a.389.389 0 0 0-.395-.382h-1.415a.389.389 0 0 0-.396.382v6.677c0 .211.177.382.396.382h1.584c.218 0 .395-.17.395-.382v-2.322c0-.967.06-1.63.182-1.99a1.65 1.65 0 0 1 .672-.863 1.954 1.954 0 0 1 1.107-.326c.321 0 .596.076.824.228.229.152.393.365.495.64.101.274.152.88.152 1.814v2.82c0 .21.177.381.396.381h1.583c.219 0 .396-.17.396-.382v-3.781c0-.669-.044-1.182-.13-1.541a2.485 2.485 0 0 0-.466-.962z"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLinkedIn);
export default __webpack_public_path__ + "static/media/linked-in.8d1e8e576f8413031168553c752ab95f.svg";
export { ForwardRef as ReactComponent };